import {Injectable} from '@angular/core';
import {Http} from "@angular/http";
import {Subscription} from "rxjs";
import {Observable} from "rxjs";
import { GlobalService } from "../providers/global.config";
@Injectable()
export class GeocodingService {

    geocodingSubscription: Subscription;
    token: string;
    
    constructor(private _http: Http,private globalService : GlobalService) {
    }
    distance(lat1, lon1, lat2, lon2) {
        var p = 0.017453292519943295;    // Math.PI / 180
        var c = Math.cos;
        var a = 0.5 - c((lat2 - lat1) * p) / 2 +
            c(lat1 * p) * c(lat2 * p) *
            (1 - c((lon2 - lon1) * p)) / 2;
        var distance = 12742 * Math.asin(Math.sqrt(a));
        return distance;
    }

    inverseGeoconding(latitude: number, longitude: number, zoom: number): Observable<any> {
        let nominatim_dns = this.globalService.getnominatim_dns();
        return this._http.get(nominatim_dns + '/reverse.php?format=json&lat=' + latitude + '&lon=' + longitude + '&zoom=' + zoom + '&accept-language=fr&addressdetails=1').map(res => res.json());
    }

    getMyIpAdress(): Observable<{ip: string}> {
        return this._http.get('http://api.ipify.org/?format=json').map(res => res.json());
    }

    getMyLocation(ip: string) {
        return this._http.get('freegeoip.net/json/' + ip).map(res => res.json());
    }
    /**proccessing on nominatim response */
  proccessingNomitamAddress(addressWasReturned: any) {
    let address = null;
    /**addressWasReturned : get address as json object*/
    let pattern = /[^\x00-\x7F|'é'|'è'|'ù'|'à'|'Ê'|'â'|'ô'|'î'|'û']\^ +| +$|( )+/g;
    /**
     *  don't replace any char that appear in this (|'é'|'è'|'ù'|'à'|'Ê'|'â'|'ô'|'î'|'û')
     * ^\x00-\x7F replace all non asccii char
     *  replace any char in pattern with signe space
     * ^ + : any sequence of spaces at the beginning of the string
     *  +$ : any sequence of spaces at the end of the string
     *  () any sequence of spaces that matches none of the above
     */
    if (addressWasReturned.address) {
      let road;
      let city;
      let suburb;
      let postcode;
      try {
        road = addressWasReturned.address.road.replace(pattern, ' ');
      } catch (error) {}
      try {
        city = addressWasReturned.address.city.replace(pattern, ' ');
      } catch (error) {}
      try {
        suburb = addressWasReturned.address.suburb.replace(pattern, ' ');
      } catch (error) {}
      try {
        postcode = addressWasReturned.address.postcode.replace(pattern, ' ');
      } catch (error) {}
      if (road && city && suburb && postcode) {
        return road + ',' + city + ',' + suburb + ',' + postcode;
      }
      if (road && city && suburb) {
        return road + ',' + city + ',' + postcode;
      }
      let district;
      try {
        district = addressWasReturned.address.state_district.replace(
          pattern,
          ' '
        );
      } catch (error) {}
      if (road && district && postcode) {
        return road + ',' + district + ',' + postcode;
      }
    }
    if (addressWasReturned.display_name) {
      let display_name = addressWasReturned.display_name.split(',');
      let i = 1;
      let iterate = true;
      let city = '';
      try {
        let road = display_name[0].replace(pattern, ' ');
        city = display_name[1].replace(pattern, ' ');
        let country = display_name[display_name.length - 1].replace(
          pattern,
          ' '
        );
        if (road && city && country) return road + ',' + city + ',' + country;
      } catch (error) {}
    }
    if (addressWasReturned.display_name) {
      let truncatedDisplayName = addressWasReturned.display_name;
      let countCommas = 0;
      for (
        var i = 0, len = addressWasReturned.display_name.length;
        i < len;
        i++
      ) {
        if (addressWasReturned.display_name[i] == ',') {
          countCommas = countCommas + 1;
        } else if (countCommas >= 5) {
          try {
            truncatedDisplayName = addressWasReturned.display_name.substring(
              0,
              i - 1
            );
            return truncatedDisplayName.replace(pattern, ' ');
          } catch (error) {
            if (truncatedDisplayName) return truncatedDisplayName;
          }
        }
      }
    }
  }

}


// WEBPACK FOOTER //
// ./src/utils/geocoding.service.ts